export const createApiErrorHandler = ({ notify, logoutAction, apiServices = [] }) => (store) => (next) => (action) => {
  const previousToken = store.getState()?.authSlice?.token;
  const result = next(action);
  const currentToken = store.getState()?.authSlice?.token;

  // Account data from one session must not be reused after logging out or switching users.
  if (previousToken !== currentToken) {
    // Let the fulfilled mutation resolve before removing its cached result.
    queueMicrotask(() => {
      if (store.getState()?.authSlice?.token === currentToken) apiServices.forEach((api) => store.dispatch(api.util.resetApiState()));
    });
  }
  if (!action.type?.endsWith('/rejected') || action.meta?.aborted || !action.payload) return result;
  const { data, status } = action.payload;
  const publicAuth = action.type.startsWith('authApi/') && ['login', 'signup', 'forgetPassword', 'resetPassword', 'verifyEmailToken', 'sendVerificationToken'].includes(action.meta?.arg?.endpointName);
  const requestAuthorization = action.meta?.baseQueryMeta?.request?.headers?.get?.('Authorization');
  // An old in-flight response must not invalidate a subsequently signed-in account.
  if (status === 401 && currentToken && requestAuthorization === `Bearer ${currentToken}` && !publicAuth) {
    store.dispatch(logoutAction());
  }
  // Pages show their own query errors; avoid flooding the screen during an outage.
  if (action.meta?.arg?.type === 'mutation' && !action.type.startsWith('orderApi/')) {
    const message = typeof data?.message === 'string' ? data.message
      : 'Det gick inte att ansluta. Försök igen om en stund.';
    notify(message);
  }
  return result;
};
